"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiPaginationItemOverrides = void 0;
var createMuiPaginationItemOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            color: palette.text.secondary,
            margin: 0,
        },
        page: {
            "&:hover": {
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
            },
            "&$focusVisible": {
                color: palette.text.primary,
                boxShadow: "inset 0px 0px 0px 1px " + palette.common.white,
            },
            "&:active": {
                color: palette.text.primary,
                backgroundColor: palette.action.active,
            },
            "&$selected": {
                color: palette.text.primary,
                "&:hover, &$focusVisible": {
                    backgroundColor: palette.action.hover,
                },
            },
        },
    });
};
exports.createMuiPaginationItemOverrides = createMuiPaginationItemOverrides;
//# sourceMappingURL=MuiPaginationItem.js.map